import axios from 'axios'
import store from '@/store'
import utilsAuth from '@/utils/auth'
import utilsIndex from '@/utils/index'
import qs from 'qs'
import md5 from 'md5'
import $Loader from '@/components/loader'
import $Message from '@/components/message'
import router from '@/router'

const client = axios.create({
    baseURL: window._getApiUrl(),
    withCredentials: true,
    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
})

const addBaseParams = (data = {}) => {
    let params = Object.assign({}, data)
    params.timestamp = utilsIndex.dateFormat({millisecond: +new Date()})

    const accessToken = utilsAuth.getAccessToken()
    if (accessToken) {
        params.token = accessToken
    }

    // 数据签名
    const saltToken = utilsAuth.getSaltTokenToken()
    let dataKey = Object.keys(params)
    let md5Str = ''
    dataKey.sort()
    dataKey.forEach((item, index, array) => {
        md5Str = md5Str + item
        for (let name in params) {
            if (name === item) {
                if (typeof params[name] === 'object') {
                    params[name] = JSON.stringify(params[name])
                }
                md5Str = md5Str + params[name]
            }
        }
    })
    md5Str = saltToken + md5Str + saltToken
    params.sign = md5(md5Str)

    return params
}

client.interceptors.request.use(
    config => {
        showLoader(config.data)

        config.data = qs.stringify(addBaseParams(config.data))
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

client.interceptors.response.use(res => {
    $Loader.hide()

    if (res.data.status === 'fail' && res.data.code === 415) {
        // 升级接口处理
        let _data = res.data.data;
        // 如果有指定店铺，则需要指定店铺的升级
        if (_data && _data.shop_id) {
            router.replace({name: 'shopupgrade', query:{shop_id: _data.shop_id}})
        } else {
            router.replace({name: 'shopupgrade'})
        }
    }

    // 如果是下载文件
    if (res.headers && /application/.test(res.headers['content-type'])) {
        const config = res.config
        if (config.method === 'post') {
            downloadPost(config)
        } else if (config.method === 'get') {
            downloadGet(config)
        }
    }

    // token失败 或 签名失败
    if (res.data.status === 'fail') {
        switch (res.data.code) {
            case '502':
            case '503':
            case 'user_token_error':
                // 401 清除token信息并跳转到登录页面
                store.dispatch('LogOut').then(data => {
                    $Message.danger({
                      content: '登录失效，请重新登录',
                      onClose: () => {
                        router.replace({ name: 'signin' })
                      }
                    })
                })
                break;    
        }
    }

    return res
}, error => {
    $Loader.hide()
    
    if (error && error.response && error.response.status) {
        switch (error.response.status) {
            case 400:
                error.msg = '错误请求'
                break;
            case 401:
                error.msg = '未授权，请重新登录'
                break;
            case 403:
                error.msg = '拒绝访问'
                break;
            case 404:
                error.msg = '请求错误,未找到该资源'
                break;
            case 405:
                error.msg = '请求方法未允许'
                break;
            case 408:
                error.msg = '请求超时'
                break;
            case 500:
                error.msg = '服务器端出错'
                break;
            case 501:
                error.msg = '网络未实现'
                break;
            case 502:
                error.msg = '网络错误'
                break;
            case 503:
                error.msg = '服务不可用'
                break;
            case 504:
                error.msg = '网络超时'
                break;
            case 505:
                error.msg = 'http版本不支持该请求'
                break;
            default:
                error.msg = `连接错误${error.response.status}`
        }
    } else {
        error.msg = '连接错误'
    }
    if (error.data) {
        error.data.status = 'fail'
        error.data.msg = error.msg
    }
    return Promise.reject(error)
})

const downloadPost = (config) => {
    const url = config.url
    const data = typeof config.data === 'object' ? JSON.parse(config.data) : qs.parse(config.data)
    const form = document.createElement('form')
    form.action = url
    form.method = 'post'
    form.style.display = 'none'
    Object.keys(data).forEach(key => {
        const input = document.createElement('input')
        input.name = key
        input.value = data[key]
        form.appendChild(input)
    })
    const button = document.createElement('input')
    button.type = 'submit'
    form.appendChild(button)
    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
}

const downloadGet = (config) => {
    const params = []
    for (const item in config.params) {
        params.push(`${item}=${config.params[item]}`)
    }
    const url = params.length ? `${config.url}?${params.join('&')}` : `${config.url}`
    let iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
        document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
}

function showLoader (data = {}) {
    if (data._LoaderConfig !== 'undefined' && data._LoaderConfig === false) {
        delete data._LoaderConfig
        return false
    }

    const config = data._LoaderConfig || {}
    delete data._LoaderConfig

    $Loader.show(config)
}

export default client



// WEBPACK FOOTER //
// ./src/utils/request.js